import React,{Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./Resources/bootstrap/dist/new_css/bootstrap.css";
// import './bootstrap/installReactBootstrapInterceptors';
import './i18n'
import swDev from './swDev';
import CryptoJS from "crypto-js";
import forge from 'node-forge';
import secureLocalStorage from 'react-secure-storage';
import loadingTranslation from "../src/loadingTranslation.json"
import { formStateStore } from './Redux/Store/store';
import { updateContainerInfo } from './Redux';
import { reset, updateStateInRedux, updateFormStateContextWithoutRender, updateStore } from './Redux/Actions/FormStateActions';
import { fetchGridStates, getFormJsonFromStore, getFormMataData, getReduxContexts, getTabActiveIndex } from './components/IFormDesignerLayout/IFormDesignerLogic';
import { functions } from './components/IFormDesignerLayout/ApplicationAPI/applicationApi';
import axios from 'axios';
import { getEncivf_gcm, getEncKey_gcm } from './Resources/globalFunctions';
import { loadConfig } from './url';//Please don't remove this line
import { getContainerId } from './components/IFormDesignerLayout/IFormDesignerLogic';
const App= React.lazy(()=> import("./App"));

//Function to get the Build No
function generateBuildNumber(){

  axios.get(`${window.location.origin}${process.env.REACT_APP_PUBLIC_URL}/GetBuildVersion`).then((res) =>{
    console.log("generateBuildNumber",res.data);
    window.buildNumber_iforms_fb= res?.data?.toString()?.split(".")[1];
  }
  )
  console.log("generateBuildNumber",window.buildNumber_iforms_fb);

  return window.buildNumber_iforms_fb || Math.floor(Math.random() * 10000);
}
function generateBuildNumberSync() {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `${window.location.origin}${process.env.REACT_APP_PUBLIC_URL}/GetBuildVersion`, false); // false = synchronous
    xhr.send(null);

    if (xhr.status === 200) {
      const data = xhr.responseText;
      window.buildNumber_iforms_fb = data?.toString()?.split(".")[1];
      return data?.toString()?.split(".")[1];
    } else {
      console.error("Error fetching build version:", xhr.status);
      return window.buildNumber_iforms_fb || Math.floor(Math.random() * 10000);
    }
  } catch (err) {
    console.error("XHR error:", err);
    return window.buildNumber_iforms_fb || Math.floor(Math.random() * 10000);
  }
}

function getBuildNo(){
  const context = process.env.REACT_APP_PUBLIC_URL?.slice(1);
  if(window.buildNumber_iforms_fb){
    return window.buildNumber_iforms_fb
  }
  else if(window?.ContextBuildNumberMap?.[context]) {
    return window.ContextBuildNumberMap[context]?.BuildNumber;
  }
  else{
    const build= generateBuildNumberSync();
    console.log("generateBuildNumber",build);

    return build || Math.floor(Math.random() * 10000);
  } 
}
window.getBuildNo = () => {
  return getBuildNo()
}

function getJsfileContext()
{

  var relative_context;
  var relative_context_bool;

  if( window.loadIformClientFromBackendContext && window?.WDeskData?.Processname ){

    relative_context_bool = window.loadIformClientFromBackendContext(window?.WDeskData?.Processname);

    if(relative_context_bool){

      const windowKey = `iform_backend_context_${window?.WDeskData?.Processname}`
      // window[windowKey] = props.backend_app_context;

      relative_context = `${window[windowKey]}/js`;
    }
    else{
      relative_context = process.env.REACT_APP_PUBLIC_URL;
    }
  }
  else{
    relative_context = process.env.REACT_APP_PUBLIC_URL;
  }
  return relative_context;
}

function loadFonts(){
  console.log("loadfonts");

  if(window?.getExternalFonts){
    const externalFonts= window.getExternalFonts();
    externalFonts?.forEach((fontName) => {
      console.log("loadfonts", fontName);
      try {
        let url = `url(${getJsfileContext()}/fonts/${encodeURIComponent(fontName)}.ttf)`;
        const myFont = new FontFace(`${fontName}`, url);
        myFont.load();
        document.fonts.add(myFont);
        console.log("loadfonts", fontName, myFont);
      } catch {
        console.log("error due to fonts: ", fontName);
      }
    });
    // externalFonts?.map((fontName)=>{
    //     console.log("loadfonts", fontName);
    //   try{

    //     let url = `url(${getJsfileContext()}/fonts/${encodeURIComponent(fontName)}.ttf)`;
    //     const myFont = new FontFace(`${fontName}`, url );
    //     myFont.load();
    //     document.fonts.add(myFont);
    //     console.log("loadfonts", fontName, myFont);
    //   }
    //   catch{
    //     console.log("error due to fonts: ", fontName );
    //   }

    //     // font-family: 'Playfair Display';
    //     // src: url(./fonts/Playfair_Display/PlayfairDisplay-Italic.ttf);
    //     // font-style: italic;
    //     // font-weight: 100;
    //   })
    }
  }

function loadScripts(filePaths, relative_context) {
  return Promise.all(filePaths.map((filePath, fileIndex) => {
    return new Promise((resolve, reject) => {
      const path = `${relative_context}${filePath}?version=${window.buildNumber_iforms_fb}`;
      
      if (path) {
        const script = document.createElement('script');
        script.setAttribute('src', path);
        script.setAttribute('id', `iformClient_js_psh${fileIndex}`);
        
        script.onload = () => {
          console.log(`✅ Loaded script: ${path}`);
          resolve();
        };

        script.onerror = () => {
          console.error(`❌ Failed to load script: ${path}`);
          reject();
        };

        document.body.appendChild(script);
      }
    });
  }));
}

async function getExternalFilesPaths(){
  if(window?.getExternalJSPaths){
    var relative_context = getJsfileContext();
    var filePaths= window?.getExternalJSPaths();
    if (filePaths && filePaths.length > 0) {
      try {
        // Step 1: Load the first set of scripts
        await loadScripts(filePaths, relative_context);

        console.log("✅ All scripts (including dynamically added ones) are loaded.");
        formStateStore.dispatch(updateStateInRedux({ name: "iformClientLoaded", value: true }));
        loadFonts();
        if(window?.WDeskData?.Processname)
          window[window.WDeskData.Processname] = true;

      } catch (error) {
        console.error("❌ Some scripts failed to load:", error);
        formStateStore.dispatch(updateStateInRedux({ name: "iformClientLoaded", value: false }));
      }
    }
    else{
      formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      loadFonts();
      if(window?.WDeskData?.Processname)
        window[window.WDeskData.Processname] = true;
    }
  }
}

const metaTag = document.querySelector('meta[id="mui-meta"]');
    
if (metaTag) {
  const value = metaTag.getAttribute('content');
  formStateStore.dispatch(updateStore({ name: "noncevalue", value: value}))
}

const cspResponse =()=>{
let uniqueNumber;
const equiv = 'Content-Security-Policy';
// if (!from_micro_frontend) {
  var xhttp = new XMLHttpRequest();

  xhttp.open("POST", '/oap-rest/app/init_app', false);
  xhttp.setRequestHeader('Content-Type', 'application/json');
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      let headers = xhttp.getResponseHeader('Content-Security-Policy');
      if (headers) {
        const regex = /'nonce-([^']+)'/;
        const match = regex.exec(headers);
        if (match) {
          uniqueNumber = match[1];
          formStateStore.dispatch(updateStore({ name: "noncevalue", value: uniqueNumber}))
          document
            .querySelector('#unique-number')
            .setAttribute('content', headers);
          document.querySelector('#unique-number').setAttribute('http-equiv', 'Content-Security-Policy');
          document.querySelector('#mui-meta').setAttribute('content', uniqueNumber);
          // document.querySelector('#google-api').setAttribute('nonce', uniqueNumber);
          // document.querySelector('#google-gsi').setAttribute('nonce', uniqueNumber);
        }
      }
    }
  };
  xhttp.send();
}

window.setContainerId = (containerId) => {
    if(containerId==="ngform") {
      window.istaskOpen= true;
    }
    else{
      window.istaskOpen= false;
    }
    formStateStore.dispatch(updateContainerInfo({ key: containerId }))
  }

function loadIformClient(){
  // const buildnum = generateBuildNumberSync();
  // console.log(buildnum);
  if(!window.location.pathname.includes("afb_subform")){
    var relative_context = getJsfileContext();
    const isIformClientLoaded = document.querySelector(`script[src*="${relative_context}/iformclient.js"]`);
    console.log("inside loadIformClient:", isIformClientLoaded, window.location.pathname)
    if(isIformClientLoaded===null){
      const iformClient_url= `${relative_context}/iformclient.js?version=${getBuildNo()}`;
      var script = document.createElement('script');
      script.setAttribute('src', iformClient_url);
      script.setAttribute('id', "iformClient_js_psh");
      script.onload= () =>{ 
        getExternalFilesPaths();
        var filePaths= window?.getExternalJSPaths();
        console.log("inside loadIformClient filepath:", filePaths, window?.location?.pathname)
        if(!window?.getExternalJSPaths()?.length){
          formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
          loadFonts();
          if(window?.WDeskData?.Processname)
            window[window.WDeskData.Processname] = true;
        }
      }
      document.body.appendChild(script);
    } 
  }
}

const localeKey=secureLocalStorage.getItem("locale");
    if(localeKey){
      localStorage.setItem("locale",localeKey);
      if(window?.psh_configs?.selectedLanguage)
        window.psh_configs.selectedLanguage= localeKey || navigator.language || navigator.userLanguage;
    }
      
const translationStyles1=window?.psh_configs?.selectedLanguage;
  // if(process.env.REACT_APP_PUBLIC_URL === "/psh"){
    console.log("loadIformClient")
    loadIformClient();
  // }



function loadIdesignfrm(){
  var relative_context = getJsfileContext();
  const idesignfrmLoaded = document.querySelector(`script[src="${relative_context}/idesignfrm.js"]`);
  if(idesignfrmLoaded===null){
    const idesignfrm_url= `${relative_context}/idesignfrm.js`;
    var script = document.createElement('script');
    script.setAttribute('src', idesignfrm_url);
    script.setAttribute('id', "idesignfrm_js_psh");
    document.body.appendChild(script);
  }
}
  loadIdesignfrm();

function loadInterfaceUtil(){
  var relative_context = getJsfileContext();
  const isInterfaceUtilLoaded = document.querySelector(`script[src="${relative_context}/interfaceutil.js"]`);
  if(isInterfaceUtilLoaded===null){
    const interfaceUtil_url= `${relative_context}/interfaceutil.js`;
    var script = document.createElement('script');
    script.setAttribute('src', interfaceUtil_url);
    script.setAttribute('id', "interfaceutil_js_psh");
    document.body.appendChild(script);
  }
}
if(process.env.REACT_APP_PUBLIC_URL === "/psh"){
  loadInterfaceUtil()
}

//getExternalFilesPaths();

// ***********************************  MicroFrontend component implementation for MDM Module **************************************
window.renderPreview = async (containerId, props) => {
  // const buildnum = generateBuildNumberSync();
  // console.log(buildnum);
  
    if(props.ContainerId==="ngform"){
      window.istaskOpen= true;
    }
    else{
      window.istaskOpen= false;
    }
    window.formLoaderRan = false;
    window.langChange = false; // when lang is present in QueryParam

    const container = document.getElementById(containerId);
    if(container) {
      formStateStore.dispatch(reset({key: containerId,formState: {}, resetContainerId: containerId}));
      formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
      formStateStore.dispatch(updateStateInRedux({name:"afterFormLoad",value: false}));
      formStateStore.dispatch(updateContainerInfo({ key: props.passedData?.formMataData_json?.ContainerId }))
      // var relative_context = getJsfileContext();
      // const isIformClientLoaded = document.querySelector(`script[src*="${relative_context}/iformclient.js"]`);
      // if((isIformClientLoaded && window.loadIformClientFromBackendContext && window.loadIformClientFromBackendContext(window?.WDeskData?.Processname)) || window.changeFormLocaleFunctionCalling) {
      //   formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      // }
      if(window[window?.WDeskData?.Processname]) {
        formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      }
      else if(props?.openFromBulk && containerId === "container_iform"){
        console.log("inside bulk form iformclientloaded true");
        formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      }
      if(props?.passedData?.formMataData_json?.formJson) {
        formStateStore.dispatch(updateFormStateContextWithoutRender({name: "formJsonFromMataData", value: props.passedData.formMataData_json.formJson, key: containerId}));
        delete props.passedData.formMataData_json.formJson;
        formStateStore.dispatch(updateFormStateContextWithoutRender({name: "formMataData", value: props.passedData.formMataData_json, key: containerId}));
      }
      const unloaded_app= await window.unmountPreviewManual(containerId);
      console.log(unloaded_app);
    }
    window.formLoaderRan = false;
    if(props.passedData.formMataData_json){
      
      // setTimeout(() => {

    //     if (container) {
    // // Ensure previous root is removed if exists
    //       if (container._reactRootContainer) {
    //         const existingRoot = container._reactRootContainer._internalRoot.current.child.stateNode;
    //         existingRoot.unmount();
    //       }

    //       // Create a new root for rendering
    //       const root = ReactDOM.createRoot(container);

    //       root.render(
    //         <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
    //           <App
    //             childComp="preview"
    //             history={props}
    //             data={props.passedData}
    //             formMataData={props.passedData.formMataData_json}
    //             appDesignerCallback={props?.Callback}
    //             containerId={containerId}
    //           />
    //         </Suspense>
    //       );

    //       // Store the root in the container for cleanup later if needed
    //       container._reactRoot = root;
    //   }

        ReactDOM.render(
          <Suspense fallback={<div className="Loading_fallback"> {""}</div>}>
            <App 
              childComp="preview" 
              history={props} 
              data={props.passedData} 
              formMataData={props.passedData.formMataData_json}
              appDesignerCallback={props?.Callback}
              containerId={containerId}
            />
          </Suspense>,
          document.getElementById(containerId)
        );
  
      // }, 2000);
    }
    else{

      //   if (container) {
      // // Ensure previous root is removed if exists
      //       if (container._reactRootContainer) {
      //         const existingRoot = container._reactRootContainer._internalRoot.current.child.stateNode;
      //         existingRoot.unmount();
      //       }

      //       // Create a new root for rendering
      //       const root = ReactDOM.createRoot(container);

      //       root.render(
      //         <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
      //           <App
      //             childComp="preview"
      //             history={props}
      //             data={props.passedData}
      //             formMataData={props.passedData.formMataData_json}
      //             appDesignerCallback={props?.Callback}
      //             containerId={containerId}
      //           />
      //         </Suspense>
      //       );

      //       // Store the root in the container for cleanup later if needed
      //       container._reactRoot = root;
      //   }
        ReactDOM.render(
          <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
            <App 
              childComp="preview" 
              history={props} 
              data={props.passedData} 
              formMataData={props.passedData.formMataData_json}
              appDesignerCallback={props?.Callback}
              containerId={containerId}
            />
          </Suspense>,
          document.getElementById(containerId)
        );
    
    }  
};

// window.callOnlyOnce = true;

window.renderPreviewInFrame = (containerId, props) => {

  if(props.ContainerId==="ngform"){
    window.istaskOpen= true;
  }
  else{
    window.istaskOpen= false;
  }
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  window.formLoaderRan = false;
  window.langChange = false; // when lang is present in QueryParam
  formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
  formStateStore.dispatch(updateStateInRedux({name:"afterFormLoad",value: false}));
  ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
        <App 
          childComp="preview" 
          history={props} 
          data={props.passedData} 
          formMataData={props.passedData.formMataData_json}
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
      </Suspense>,
    document.getElementById(containerId)
  );
};

// Reusable Business Function
window.renderReusableBusinessFunction = (containerId, props) => {
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  window.formLoaderRan = false;
  window.langChange = false; // when lang is present in QueryParam
  formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
  formStateStore.dispatch(updateStateInRedux({name:"afterFormLoad",value: false}));
  ReactDOM.render(
    <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
      <App 
          childComp="reusableFunction" 
          history={props} 
          data={props.passedData} 
          formMataData={props.passedData.formMataData_json}
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
    </Suspense>,
    document.getElementById(containerId)
  )
}

// window.unmountPreview = (containerId) => {
//   const container = document.getElementById(containerId);
//   if (container && container._reactRoot) {
//     container._reactRoot.unmount();
//     delete container._reactRoot;
//     return true;
//   }
//   return false;
// };
window.unmountPreview = containerId => {
  if(document.getElementById(containerId)){
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};


window.unmountPreviewManual = (containerId) => {
  // const container = document.getElementById(containerId);
  // if (container && container._reactRoot) {
  //   container._reactRoot.unmount();
  //   delete container._reactRoot;
  //   return true;
  // }
  // return false;
  if(document.getElementById(containerId)){
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};


window.unmountPreviewInFrame = containerId => {
  // const container = document.getElementById(containerId);
  // if (container && container._reactRoot) {
  //   container._reactRoot.unmount();
  //   delete container._reactRoot;
  //   return true;
  // }
  // return false;
  if(document.getElementById(containerId)){
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};

//  ************************************** ************************************** **************************************************

// ***********************************  MicroFrontend component implementation for MDM Module **************************************
window.renderApp = (containerId, props) => {
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  // const container = document.getElementById(containerId);

  // if (container) {
  //   if (!container._reactRoot) {
  //     container._reactRoot = ReactDOM.createRoot(container);
  //   }
  //   const metaTag = document.querySelector('meta[id="mui-meta"]');
  //   if (metaTag) {
  //     const value = metaTag.getAttribute('content');
  //     formStateStore.dispatch(updateStore({ name: "noncevalue", value: value, key: containerId}));
  //   }

  //   container._reactRoot.render(
  //     <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
  //       <App
  //         childComp="app"
  //         history={props}
  //         data={props.passedData}
  //         appDesignerCallback={props?.Callback}
  //         containerId={containerId}
  //       />
  //     </Suspense>
  //   );
  // }
  if(document.getElementById(containerId)){

    ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
        <App 
          childComp="app" 
          history={props} 
          data={props.passedData} 
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
          />
      </Suspense>,
      document.getElementById(containerId)
    );
  }
};

window.unmountApp = containerId => {
  // const container = document.getElementById(containerId);
  // formStateStore.dispatch(reset({key: "default",formState: {}, resetContainerId: "default"}));
  // if (container && container._reactRoot) {
  //   container._reactRoot.unmount();
  //   delete container._reactRoot;
  //   return true;
  // }
  // return false;
  formStateStore.dispatch(reset({key: "default",formState: {}, resetContainerId: "default"}));
  if(document.getElementById(containerId)){
    ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};

window.postToApp = ({ type, payload}) =>{

  switch(type){
    case "applicationPages":  
  }
}

if ( (window.formBuilder_containerId_mf && !document.getElementById(window.formBuilder_containerId_mf) && document.getElementById('psh_root_not_mf') ) || window.formBuilder_containerId_mf===undefined ) {
  formStateStore.dispatch(reset({key: "default",formState: {}, resetContainerId: "default"}));
  formStateStore.dispatch(updateContainerInfo({key:"default"}));

     ReactDOM.render(     
      <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
        { !window.location.href.includes("processDesigner") && !window.location.href.includes("afb_subform") && cspResponse()}
        <App childComp="app" containerId={"default"} />
      </Suspense>
        , document.getElementById('psh_root_not_mf'));
}

// ************************************** ************************************************************************************************************************ //


// ****************************************************************** MICROFRONTE END IMPLEMENTTAION ************************************************************* //

const state=formStateStore.getState();
   let containerId = getContainerId();
  if(containerId===undefined){
    containerId="default"
  }
 let nonceValue= state.data.find(json => json.key === containerId)?.noncevalue;


window.MdmDataModel = function (appId , appName, parentDataObjects, parentDataObjectId){
  var props = {
    "uniqueNumber" : nonceValue,
   "Module": "MDM",
   "Component": "DataModelListViewer",
   "InFrame": false,
   "ContainerId": "dataModel_mf",
   "Renderer":"renderDataModelListViewer",
   "Callback":null,
   "source": "AP",
   "auto_generate_table": true,
   "object_type": "AP",
   "object_id": appId,
   "object_name": appName || "Application Name",
   "default_data_fields": [
      {
        "name": "referencekey",
        "alias": "referencekey",
        "type": 1,
        "key_field": true,
        "id": 1
      }
    ],
    data_types: [1,2,3,4,5,8,9,10],
   "Unmount": "unmountDataModelListViewer",
   "parentDataObject":parentDataObjects,
   "parentDataObjectId":parentDataObjectId,
  }
  if(window && window?.loadMicroFrontend ){
    window.loadMicroFrontend(props);
  }
}

window.openDocumentViewer = function (translation, dir, docClicked, docData = {}, containerId){
  const state=formStateStore.getState();
 let nonceValue = state.data.find(json => json.key === containerId)?.noncevalue;

  var doc_viewer_props = {
    "uniqueNumber": nonceValue,
    "t":translation || "",
    "direction":dir,
    "source" :"IFORM",
    "dms_type" : docData.dms_type || "1",
    "isPortal" : docData.isPortal,
    "documentInfoProps": docClicked,
    "SetDocumentDataProps": {
              available_doc_types: docData?.available_doc_types,
              upload_doc_as: docData?.upload_doc_as,
              documents: docData?.documents
            },
    "Component": "DocumentViewer",
    "Module": "WCL",
    "InFrame": false,
    ...(docData.isMicroServiceMode ? { isMicroServiceMode: docData.isMicroServiceMode } : {}),
    ...(docData.userIndex ? { userIndex: docData.userIndex } : {}),
    ...(docData.userDBId ? { userDBId: docData.userDBId } : {}),
    "ContainerId": containerId
  }
      if(window && window?.loadMicroFrontend ){
        window.loadMicroFrontend(doc_viewer_props);
      }
}

window.loadIntegrator = function () {
  const path = `/integration/integration.js?version=${getBuildNo()}`;
  const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
      window.docListIntegratorPresent= true;
    }
    document.head.appendChild(script);
}

var loadSessionPopup_count=0;
window.loadSessionPopup = function (props) {
  if (window && window?.loadMicroFrontend && window.MicroAppsMap && Object.keys(window.MicroAppsMap).length > 0 && document.querySelector(`#${props?.ContainerId}`) ) {
    window.loadMicroFrontend(props);
  }
  else if (loadSessionPopup_count < 5){
    window.setTimeout(()=>{
      loadSessionPopup_count = loadSessionPopup_count + 1;
      window.loadSessionPopup(props);
    },2000);
  }
};

window.loadIntegrator_bam = function () {
  const path = `/integration/integration.js?version=${getBuildNo()}`;
  const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
       window.docListIntegratorPresent= true;
    }
    document.head.appendChild(script);
}

window.docListIntegratorPresent= false;
window.loadDoclistComponent = function (loadDoc, docData) {
  const scriptInt = document.createElement('script')
  scriptInt.type = 'text/javascript'
  scriptInt.src =`/integration/integration.js?version=${getBuildNo()}`;
  scriptInt.id= "loadDoclistIntegration"
  scriptInt.onload= () => {
 }
  document.body.appendChild(scriptInt)  

  return true
}

window.loadDoclist = function (props){
  if(window.renderDocumentListViewer)
    window.renderDocumentListViewer(props.ContainerId,{...props, Renderer: "renderDocumentListViewer",Unmount: "unmountDocumentListViewer"});
  else window?.loadMicroFrontend(props);
}

window.setParent_auth_iforms = (value) =>{
    window[`authorizationtokenNotsecure`] = value;
  }

  window.parent_auth_iforms = () =>{
    return window[`authorizationtokenNotsecure`];
  }

  window.showMandatoryFieldsOnDone = (res) => {
      if(res.controlId) {
        const parentList = res.controlId.split(":");
        const formjson = getFormJsonFromStore();
        for(let i = 0; i < parentList.length - 1; i++){
          if(parentList[i].includes("frame")) {
            if(window?.["temporaryVariables"]?.[`${parentList[i]}_collapsedState`] === true || window?.["temporaryVariables"]?.[`${parentList[i]}_collapsedState`] === true) {
              functions.setStyle(parentList[i],"sectionstate","expanded");
              functions.render = true;
              functions.updateJSON();
            }
          } else if(parentList[i].includes("tab")) {
              let tabId = parentList[i];
              let tabJson = functions.readJson(formjson,parentList[i]);
              const tabActiveIndex = getTabActiveIndex();
              const currentTabActiveIndex = tabActiveIndex[tabId];
              let sheetIndex = tabJson?.children?.findIndex(function(child){return child.id.toLowerCase()=== parentList[i+1] })
              let sheetName = tabJson?.children?.[sheetIndex]?.tabChildName;
              if(currentTabActiveIndex.toString() !== sheetIndex.toString()) {
                functions.selectSheetByName(tabId, sheetName);
                functions.render = true;
                functions.updateJSON();
              }
            }
        }
        window.isComponentValidated();
      }
    }

  window.encryptSurveyManual= function(value, key)  {
      var rkEncryptionKey = CryptoJS.enc.Base64.parse(key || "u/Gu5posvwDsXUnV5Zaq4g==");
      var rkEncryptionIv = CryptoJS.enc.Base64.parse("5D9r9ZVzEYYgha93/aUK2w==");
      if(value !== "" && value !== undefined) {
      return CryptoJS.AES.encrypt(value, rkEncryptionKey, {
      iv: rkEncryptionIv
      }).toString();
    }
  };

  window.documentPostHookExt = function (docResponse) {
    if(window?.documentPostHook) {
      window.documentPostHook(docResponse);
      functions.updateJSON()
    }
  }
    
  window.decyptManual = function(value) {
    var rkEncryptionKey = CryptoJS.enc.Base64.parse("u/Gu5posvwDsXUnV5Zaq4g==");
    var rkEncryptionIv = CryptoJS.enc.Base64.parse("5D9r9ZVzEYYgha93/aUK2w==");
    if(value !== "" && value !== undefined) {
    const decrypted = CryptoJS.AES.decrypt(value, rkEncryptionKey, {
      iv: rkEncryptionIv
    });
    
    console.log("decrypted",decrypted);

    if (decrypted) {
        const str = decrypted.toString(CryptoJS.enc.Utf8);

      console.log("decrypted", str );

        if (str.length > 0) {
          return str;
        } 
      } 
    return "";
    }
  }
    
    
    window.encryptSurveyManual2= function(value, key)  {
        // key here is "user_secret_key_"
    
        // var rkEncryptionKey = CryptoJS.enc.Base64.parse(key );
        // var rkEncryptionIv = CryptoJS.enc.Base64.parse("Interface_Viewer");
    
        var rkEncryptionKey = CryptoJS.enc.Utf8.parse(key);
        var rkEncryptionIv = CryptoJS.enc.Utf8.parse("Interface_Viewer");
    
        if(value !== "" && value !== undefined) {
    
        // const ciphertext = CryptoJS.AES.encrypt(value, rkEncryptionKey, {
        //                      keySize: 128 / 8,
        //                      iv: rkEncryptionIv,
        //                      mode: CryptoJS.mode.CBC,
        //                      padding: CryptoJS.pad.Pkcs7
        //                     }).toString();
    
        const ciphertext = CryptoJS.AES.encrypt(value, rkEncryptionKey, { rkEncryptionIv }).toString();
    
        return ciphertext
      }
    };

    window.export_encryptMessage = async (message) => {
      // defining key 
   
       var key = getEncKey_gcm();
   
   // defining init-vector for salting
   
       var ivf = getEncivf_gcm();
   
       var cipher = forge.cipher.createCipher('AES-GCM', key);
       cipher.start({ iv: ivf });
   
     cipher.update(forge.util.createBuffer(forge.util.encodeUtf8(message)));
     
       cipher.finish();
   
     console.log("cipher: ", cipher); 
     
      var tag = cipher.mode.tag.getBytes();
     
     console.log("tag: " , window.btoa(tag) );
     
       var encryptedMessage = cipher.output.getBytes();
   
     console.log("encryptedMessage: " , window.btoa(encryptedMessage) );
     
       var result = window.btoa(encryptedMessage+tag);
     
     let result_replace = result.replaceAll("=","_");
     result_replace = result_replace.replaceAll("/","~");
     result_replace = result_replace.replaceAll("+","!");
     
     console.log("result:: " ,result, result_replace );
   
       return result_replace;
   };
   
   window.export_decryptMessage = async (encryptedMessage) => {
       if(encryptedMessage){
           
      // defining key 
      var key = getEncKey_gcm();
   
      // defining init-vector for salting
          var ivf = getEncivf_gcm();
   
       // Convert custom characters back to base64
       let result_replace = encryptedMessage.replaceAll("_", "=");
       result_replace = result_replace.replaceAll("~", "/");
       result_replace = result_replace.replaceAll("!", "+");
   
       // encryptedMessage = encryptedMessage.replaceAll("_", "=").replaceAll("~", "/").replaceAll("!", "+");
     
       // Decode base64
       const decodedMessage = forge.util.decode64(result_replace);
     
       // Split the message and tag
       const tagLength = 16; // Length of the tag in bytes
       const encryptedLength = decodedMessage.length - tagLength;
       const encryptedBytes = decodedMessage.slice(0, encryptedLength);
       const tagBytes = decodedMessage.slice(encryptedLength);
     
       // Create a decipher object
       const decipher = forge.cipher.createDecipher('AES-GCM', key);
       decipher.start({ iv: ivf, tag: tagBytes });
     
       // Update with the encrypted message
       decipher.update(forge.util.createBuffer(encryptedBytes));
     
       // Finish the decryption
       const success = decipher.finish();
     
       if (!success) {
         throw new Error('Decryption failed');
       }
     
       // Get the decrypted message as Utf8
       const decryptedMessage = decipher.output.toString('utf8');
     
       console.log("decryptedMessage", decryptedMessage);
       return decryptedMessage;
       }
   };

   window.loading = (open, message = "Loading...", displayBackdrop = true, displayLoader = true) => {
      const {loading} = getReduxContexts();
      loading(open, message, displayBackdrop, displayLoader);      
   }
  
  window.isValidDataEntered = function () {
    return fetchGridStates().globalError;
  }
 
  window.selectedControlId_function = (
      controlSelectedPassed,
      controlSelectedId
    ) => {
      if (controlSelectedPassed?.elem_type === "CustomControl" && controlSelectedPassed.controlName !== "slider") {
        const newControl = {
          ...controlSelectedPassed,
          elem_type: controlSelectedPassed.controlName,
        };
        formStateStore.dispatch(updateStateInRedux({name: "controlSelected", key: containerId, value: newControl}));
        // setControlSelected((prev) => newControl);
      } else {
        formStateStore.dispatch(updateStateInRedux({name: "controlSelected", key: containerId, value: controlSelectedPassed}));
        // setControlSelected((prev) => controlSelectedPassed);
        if(controlSelectedPassed?.elem_type === 'paragraph')
          document.getElementById(`${controlSelectedPassed.id}_group`)?.classList?.add('focussedparagraph');
      }
    };

    window.isFormModified = function () {
      return ((window && (window?.afb_isFormModified !== undefined)) ? window?.afb_isFormModified : null)
    }

    window.setFormMoified = function (props) {
        window.afb_isFormModified = props;
    }


  window.postHookWISubmitEvent = () => {
    console.log("docIndexesArray",window?.docIndexesArray)
    const formMataData = getFormMataData();
    let json = {gdtoken: formMataData?.gdToken || formMataData?.gdtoken, witoken: formMataData?.witoken || formMataData?.wiToken };
    let actworkItemJson = {
      "opr": "3",
      "wid": formMataData?.wid,
      "pid": formMataData?.pid,
      "multi_delete":false,
      "task_id": "",
      "dms_type": "1"
  }
      if (window?.docIndexesArray?.length > 0) {
        window?.docIndexesArray.forEach((doc, index) => {
          actworkItemJson.multi_delete=doc?.multi_delete
          actworkItemJson.doc_index = doc?.docIndexes
          actworkItemJson.is_index = doc?.is_index
          json.controlId = doc?.controlId;
          json.docImageIndex = doc?.docIndexes;
          axios.post("/wd-rest/app/actworkitemdoc", actworkItemJson, { withCredentials: true }).then(() => {
            console.log("actworkitemDoc")
          }).catch((err) => console.log(err))       
        })
      }
  
    }

window.loadMicroFrontend_formBuilder = function (props){
  window.loadMicroFrontend(props);
}
window.MdmDataObjectsModel = function (props) {
  if (window && window?.loadMicroFrontend) {
    window.loadMicroFrontend(props);
  }
};

window.createEfficientElementMap = function (formState1) {
    const formState = window.formBuffer || formState1;
    const elementMap = new Map();  // Stores elements with primary `id`

    const aliasMap = new Map();    // Stores alias mappings for `customId` & `dataClass`
    let array = [];
    let customIdArray = [];
 
    function traverse(node) {
        if (!node) return; // Ignore invalid nodes
 
        // ✅ Store element using its `id`
        if(elementMap.has(node.id) && node.id !== "FormDef" && node.id !== "RootControl" && node.id !== "Event" && node.id !== "GroupInfo" && node.formName !== "testForm") {
          array.push(node);
        } else {
          elementMap.set(node.id, node);
        }
        if(aliasMap.has(node?.style?.CustomId) && node?.style?.CustomId) {
          customIdArray.push(node);
        } else {
          if(node?.style?.CustomId) {
            aliasMap.set(node?.style?.CustomId, node);
          }
        }
 
        // ✅ Recursively traverse nested elements
        if (node.children) {
            for (let i = 0; i < node.children.length; i++) {
                traverse(node.children[i]);
            }
        }
        if (node.subform && node.elem_type === "button") {
            traverse(node.subform);
        }
        if ((node.elem_type?.toLowerCase() === "advancelistview" || node.elem_type?.toLowerCase() === "listview") && node.listviewFrameLayoutJson) {
            traverse(node.listviewFrameLayoutJson);
        }
    }
 
    traverse(formState); // Build Maps
 
    return { elementMap, array, customIdArray };
}

Date.prototype.yyyymmdd = function(seperator="/") {
    var yyyy = this.getFullYear();
    yyyy+=seperator;
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    mm+=seperator;
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    return "".concat(yyyy).concat(mm).concat(dd);
  };

  Date.prototype.ddmmyyyy = function(seperator="/") {
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    dd+=seperator;
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    mm+=seperator;
    var yyyy = this.getFullYear();
    return "".concat(dd).concat(mm).concat(yyyy);
  };

  Date.prototype.mmddyyyy = function(seperator="/") {
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    mm+=seperator;
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    dd+=seperator;
    var yyyy = this.getFullYear();
    return "".concat(mm).concat(dd).concat(yyyy);
  };

  Date.prototype.monthNames = [
    "January", "February", "March",
    "April", "May", "June",
    "July", "August", "September",
    "October", "November", "December"
];
  
  Date.prototype.getMonthName = function() {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName()?.substr(0, 3);
  };

  Date.prototype.ddmmmyyyy = function(seperator="/") {
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    dd+=seperator;
    var mm= this.getShortMonthName();
    mm+=seperator;
    var yyyy = this.getFullYear();
    return "".concat(dd).concat(mm).concat(yyyy);
  };

  Date.prototype.yyyymmddhhmm = function() {
    var yyyymmdd = this.yyyymmdd();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    min+=":";
    var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

    return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
  };

  Date.prototype.ddmmyyyyhhmm = function() {
    var yyyymmdd = this.ddmmyyyy();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    min+=":";
    var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

    return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
  }

  Date.prototype.mmddyyyyhhmm = function() {
  var yyyymmdd = this.mmddyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  min+=":";
  var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}


 Date.prototype.ddmmmyyyyhhmm = function() {
  var yyyymmdd = this.ddmmmyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  min+=":";
  var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}

  Date.prototype.yyyymmddhhmm1 = function() {
    var yyyymmdd = this.yyyymmdd();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    // min+=":";
    // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
    return "".concat(yyyymmdd).concat(hh).concat(min)
  
  };
  
  Date.prototype.ddmmyyyyhhmm1 = function(seperator) {
    var yyyymmdd = this.ddmmyyyy();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    // min+=":";
    // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
    return "".concat(yyyymmdd).concat(hh).concat(min);
  }
  
  Date.prototype.mmddyyyyhhmm1 = function() {
  var yyyymmdd = this.mmddyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  // min+=":";
  // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
  return "".concat(yyyymmdd).concat(hh).concat(min)
  }
  
  
  Date.prototype.ddmmmyyyyhhmm1 = function() {
  var yyyymmdd = this.ddmmmyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  // min+=":";
  // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
  return "".concat(yyyymmdd).concat(hh).concat(min)
  }

window.SessionHandler = function (props) {
  if (window && window?.loadMicroFrontend) {
    window.loadMicroFrontend(props);
  }
};

Date.prototype.yyyymmdd = function(seperator="/") {
    var yyyy = this.getFullYear();
    yyyy+=seperator;
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    mm+=seperator;
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    return "".concat(yyyy).concat(mm).concat(dd);
  };

  Date.prototype.ddmmyyyy = function(seperator="/") {
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    dd+=seperator;
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    mm+=seperator;
    var yyyy = this.getFullYear();
    return "".concat(dd).concat(mm).concat(yyyy);
  };

  Date.prototype.mmddyyyy = function(seperator="/") {
    var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    mm+=seperator;
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    dd+=seperator;
    var yyyy = this.getFullYear();
    return "".concat(mm).concat(dd).concat(yyyy);
  };

  Date.prototype.monthNames = [
    "January", "February", "March",
    "April", "May", "June",
    "July", "August", "September",
    "October", "November", "December"
];
  
  Date.prototype.getMonthName = function() {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName()?.substr(0, 3);
  };

  Date.prototype.ddmmmyyyy = function(seperator="/") {
    var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
    dd+=seperator;
    var mm= this.getShortMonthName();
    mm+=seperator;
    var yyyy = this.getFullYear();
    return "".concat(dd).concat(mm).concat(yyyy);
  };

  Date.prototype.yyyymmddhhmm = function() {
    var yyyymmdd = this.yyyymmdd();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    min+=":";
    var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

    return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
  };

  Date.prototype.ddmmyyyyhhmm = function() {
    var yyyymmdd = this.ddmmyyyy();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    min+=":";
    var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

    return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
  }

  Date.prototype.mmddyyyyhhmm = function() {
  var yyyymmdd = this.mmddyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  min+=":";
  var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}


 Date.prototype.ddmmmyyyyhhmm = function() {
  var yyyymmdd = this.ddmmmyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  min+=":";
  var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  return "".concat(yyyymmdd).concat(hh).concat(min).concat(ss);
}

  Date.prototype.yyyymmddhhmm1 = function() {
    var yyyymmdd = this.yyyymmdd();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    // min+=":";
    // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
    return "".concat(yyyymmdd).concat(hh).concat(min)
  
  };
  
  Date.prototype.ddmmyyyyhhmm1 = function(seperator) {
    var yyyymmdd = this.ddmmyyyy();
    yyyymmdd+=", ";
    var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
    hh+=":";
    var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
    // min+=":";
    // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
    return "".concat(yyyymmdd).concat(hh).concat(min);
  }
  
  Date.prototype.mmddyyyyhhmm1 = function() {
  var yyyymmdd = this.mmddyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  // min+=":";
  // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
  return "".concat(yyyymmdd).concat(hh).concat(min)
  }
  
  
  Date.prototype.ddmmmyyyyhhmm1 = function() {
  var yyyymmdd = this.ddmmmyyyy();
  yyyymmdd+=", ";
  var hh = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  hh+=":";
  var min = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  // min+=":";
  // var ss = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();
  
  return "".concat(yyyymmdd).concat(hh).concat(min)
  }

swDev();